import { parseISO } from 'date-fns';
import { formatDisplayDateTime } from '../../../utils/dateFormatting';

/**
 * "Last saved" label for the TopBar: relative time for the last week, then a full date.
 * Shared by the article wizard and the article editor (previously duplicated in both pages).
 */
export function formatTimeAgo(t, date) {
  if (!date) return t('common.timeAgo.noDate');
  const now = new Date();
  const updatedDate = parseISO(date);
  const diffInSeconds = (now.getTime() - updatedDate.getTime()) / 1000;
  if (diffInSeconds < 60) return t('common.timeAgo.seconds', { count: Math.floor(diffInSeconds) });
  if (diffInSeconds < 3600) return t('common.timeAgo.minutes', { count: Math.floor(diffInSeconds / 60) });
  if (diffInSeconds < 86400) return t('common.timeAgo.hours', { count: Math.floor(diffInSeconds / 3600) });
  if (diffInSeconds < 604800) return t('common.timeAgo.days', { count: Math.floor(diffInSeconds / 86400) });
  return formatDisplayDateTime(updatedDate, localStorage.getItem('i18nextLng') || 'en');
}
